<!-- 过夜袋详情（账号登陆） -->
<template>
  <div class="backgroundGrey">
    <van-tabs v-model="status">
      <van-tab v-for="(item,index) in tabList" :title="item.name" :key="index" :name="item.id">
        <div v-if="lists.length" class="scroll-box-tab">
          <div class="details-card" v-for="(item,index) in lists" :key="index">
            <div class="detailsItem" @click="openDetails(item)">
              <div>
                <span>航班日期：</span>
                <span>{{ item.flightDateDesc }}</span>
              </div>
              <div>
                <span>航班环：</span>
                <span>{{ item.flightNoRing }}</span>
              </div>
              <div>
                <span>航段环：</span>
                <span>{{ item.flightLineRing }}</span>
              </div>
              <div>
                <span>状态：</span>
                <span>{{ item.stateDesc }}</span>
              </div>
            </div>
          </div>
        </div>
        <EmptyTips :tipsList="['暂无记录']" v-else />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import EmptyTips from '@/components/common/EmptyTips'

export default {
  components: {
    EmptyTips,
  },
  data() {
    return {
      tabList: [
        { name: '全部', id: -1 },
        { name: '已输入', id: 1 },
        { name: '已确认', id: 2 },
        { name: '已领取', id: 3 },
        { name: '已归还', id: 4 },
        { name: '已完成', id: 5 },
      ],
      status: -1,
      lists: [],
      pageParams: {
        pageSize: 50,
        pageIndex: 1,
        total: 0
      }
    }
  },
  activated() {
    this.getOveninght()
  },
  watch: {
    status: {
      handler(v) {
        this.getOveninght()
      },
    },
  },
  mounted() {
    // 分页
  },
  methods: {
    openDetails(item) {
      this.$utils.routerPush({
        name: 'OvernightBagManageDetailsOld',
        query: {
          id: item.id,
        },
      })
    },
    // 获取过夜袋详情
    getOveninght() {
      let _this = this
      let params = {
        pageSize: 10000,
        pageIndex: 1,
        searchData: {
          staffId: this.$store.state.userInfo.userId,
          state: this.status, // // -1全部即（3.已领取 4.已归还 5.已完成
          isOld: true,
          isUseEquipment: 0,
        },
      }
      this.$api.post('/api-sys/apiOverNightBag/getByPage', params).then((res) => {
        if (res.code === '0000') {
          _this.lists = res.data.list
        }
      })
    },
    subStatus(status) {
      return this.tabList.filter((i) => i.id === status)[0] ? this.tabList.filter((i) => i.id === status)[0].name : ''
    },
  },
}
</script>

<style lang="less" scoped>
.bom-btn {
  border-top: 1px solid #ededed;
  padding: 10px 0;
  overflow: hidden;
}
.empty-tips {
  height: calc(100vh - 200px) !important;
}
</style>



// WEBPACK FOOTER //
// src/view/OvernightBag/OvernightBagManageOld.vue